import { useSnackbar } from "notistack";
import { GetPlayerCategoriesStatsUseCase } from "../../../domain/usecase/player/GetCategoriesStats/GetCategoriesStatsUseCase";
import { GetAllTransactionsUseCase } from "../../../domain/usecase/transaction/getAll/GetAllUseCase";
import { useEffect, useState } from "react";
import { State } from "../../../domain/model/ResponseState";
import { Transaction } from "../../../domain/model/Transaction";
import { PlayerStatPerCategoryModel } from "../../../domain/model/User";
import { Category } from "../../../domain/model/Category";
import { Game } from "../../../domain/model/Game";
import { PlayerGetCurrentGameUseCase } from "../../../domain/usecase/player/GetCurrentGames/GetCurrentGamesUseCase";

export function DashboardViewModel(
  getPlayerCategoriesStatsUseCase: GetPlayerCategoriesStatsUseCase,
  getAllTransactionsUseCase: GetAllTransactionsUseCase,
  playerGetCurrentGameUseCase: PlayerGetCurrentGameUseCase
) {
  const { enqueueSnackbar } = useSnackbar();
  const [isGettingAllTransactions, setIsGettingAllTransactions] =
    useState(false);
  const [isGettingCategoriesStats, setIsGettingCategoriesStats] =
    useState(false);

  const [mostPickedCategory, setMostPickedCategory] = useState<
    Category | undefined
  >();

  const [transactionsDataSet, setTransactionsDataSet] = useState<Array<number>>(
    []
  );

  const [totalSpentMoney, setTotalSpentMoney] = useState(0);
  const [loading, setLoading] = useState(false);
  const [games, setGames] = useState<Array<Game>>([]);

  useEffect(() => {
    getGames();
  }, []);

  async function getGames() {
    setLoading(true);
    const response = await playerGetCurrentGameUseCase.invoke();
    switch (response.responseState) {
      case State.Success:
        if (response.data) {
          setGames(response.data);
        }
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
    setLoading(false);
  }

  async function getCategoriesStats(playerId: string) {
    setIsGettingCategoriesStats(true);
    const response = await getPlayerCategoriesStatsUseCase.invoke(playerId);
    setIsGettingCategoriesStats(false);
    switch (response.responseState) {
      case State.Success:
        if (response.data) calculateCategoriesStats(response.data);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  function calculateCategoriesStats(
    categoriesStatsList: Array<PlayerStatPerCategoryModel>
  ) {
    var currentMostPickedCategory: Category | undefined;
    var currentMostPickedCategoryNumber: number = 0;
    categoriesStatsList.map((item) => {
      if (item.numberOfSelection >= currentMostPickedCategoryNumber) {
        currentMostPickedCategory = item.category;
        currentMostPickedCategoryNumber = item.numberOfSelection;
      }
    });
    setMostPickedCategory(currentMostPickedCategory);
  }

  async function getAllTransactions() {
    setIsGettingAllTransactions(true);
    const response = await getAllTransactionsUseCase.invoke();
    setIsGettingAllTransactions(false);
    switch (response.responseState) {
      case State.Success:
        if (response.data) {
          calculateTransactionsStats(response.data);
          setTransactionsDataSet(
            calculateMonthlyData({ transactions: response.data })
          );
        }
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  function calculateTransactionsStats(transactions: Array<Transaction>) {
    var totalSpentMoney = 0;
    transactions.map((transaction) => {
      totalSpentMoney +=
        transaction.originalPriceInUSD * ((100 - transaction.discount) / 100);
    });
    setTotalSpentMoney(totalSpentMoney);
  }

  function calculateMonthlyData({
    games,
    transactions,
  }: {
    games?: Array<Game>;
    transactions?: Array<Transaction>;
  }): Array<number> {
    const dataset = [
      {
        number: 0,
        month: "Jan",
      },
      {
        number: 0,
        month: "Feb",
      },
      {
        number: 0,
        month: "Mar",
      },
      {
        number: 0,
        month: "Apr",
      },
      {
        number: 0,
        month: "May",
      },
      {
        number: 0,
        month: "Jun",
      },
      {
        number: 0,
        month: "July",
      },
      {
        number: 0,
        month: "Aug",
      },
      {
        number: 0,
        month: "Sep",
      },
      {
        number: 0,
        month: "Oct",
      },
      {
        number: 0,
        month: "Nov",
      },
      {
        number: 0,
        month: "Dec",
      },
    ];
    if (games)
      games.map((game) => {
        if (game.date) {
          const month = new Date(game.date).getMonth();
          const year = new Date(game.date).getFullYear();

          if (new Date().getFullYear() === year) {
            dataset[month].number += 1;
          }
        }
      });

    if (transactions)
      transactions.map((transaction) => {
        if (transaction.createdAt) {
          const month = new Date(transaction.createdAt).getMonth();
          const year = new Date(transaction.createdAt).getFullYear();

          if (new Date().getFullYear() === year) {
            dataset[month].number += 1;
          }
        }
      });

    return dataset.flatMap((i) => i.number);
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error"
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }

  return {
    isGettingAllTransactions,
    getCategoriesStats,
    isGettingCategoriesStats,
    mostPickedCategory,
    totalSpentMoney,
    transactionsDataSet,
    calculateMonthlyData,
    loading,
    games,
  };
}
